// extracted by mini-css-extract-plugin
module.exports = {"layout":"zJkqgG","list":"bnBEQt","item":"QMDPgE","picture":"Gm9YYB","mainItem":"pC0jnF","heading":"rJ6MH5","icon":"MQmYpk","link":"QJy_4v","back":"zTbmlS"};